import React from "react";
import { cn } from "../../utils";
import { SPACING } from "../../config/layout";

export interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  fillHeight?: boolean;
  noPaddingMobile?: boolean;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "full" | "custom";
}

const maxWidthClass = {
  sm: "max-w-screen-sm",
  md: "max-w-screen-md",
  lg: "max-w-screen-lg",
  xl: "max-w-screen-xl",
  "2xl": "max-w-screen-2xl",
  full: "max-w-none",
  custom: "max-w-[1800px]",
};

export const Container: React.FC<ContainerProps> = ({ children, className, fillHeight, noPaddingMobile, maxWidth = "custom" }) => {
  const base = noPaddingMobile ? `w-full max-lg:px-0 ${SPACING.PAGE_PADDING_X}` : `w-full ${SPACING.PAGE_PADDING_X}`;
  const fill = fillHeight ? "flex min-h-0 flex-1 flex-col min-h-full" : "";
  const max = maxWidthClass[maxWidth];
  return <div className={cn(base, fill, max, "mx-auto", className)}>{children}</div>;
};

export default Container;
